import React, { createRef } from 'react';
import './css/searchbox.css';
import PropTypes from 'prop-types';
import { ACTIVITY_TYPE, ROUTES } from '../../../const';
import routerHistory from '../../../routerHistory';
import { I18n } from 'react-redux-i18n-lite';

export default class SearcherComponent extends React.Component {
  static propTypes = {
    inputValue: PropTypes.string,
    searchResults: PropTypes.array,
    searchMode: PropTypes.bool,
    events: PropTypes.shape({
      onInputChange: PropTypes.func,
      onBrowserClick: PropTypes.func,
      onSubmit: PropTypes.func,
      onClose: PropTypes.func
    })
  };

  resultsPrinted = 0;

  state = {
    inputOpened: false,
    resultsOpened: false
  };

  constructor(props) {
    super(props);
    this.searchBoxInput = createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClose);
  }

  searchMode = () => {
    return this.state.inputOpened || this.props.searchMode;
  };

  clickSearch = e => {
    if (this.searchMode()) {
      this.setState({ resultsOpened: false });
      return this.props.events.onSubmit(e);
    }

    this.setState({ inputOpened: true });
    e.target.nextElementSibling.style.display = 'inline-flex';
    this.searchBoxInput.current.focus();
    this.props.events.onBrowserClick(e);
  };

  clickClose = e => {
    this.setState({ inputOpened: false, resultsOpened: false });
    e.target.parentNode.style.display = 'none';
    this.props.events.onClose(e);
  };

  onInputChange = e => {
    this.setState({ resultsOpened: true });
    this.props.events.onInputChange(e);
  };

  onKeyDown = e => {
    if (e.key === 'Enter') {
      const { searchResults } = this.props;
      if (this.hasResults()) {
        this.props.events.onSubmit(e);
        this.setState({ resultsOpened: false });
        if (searchResults.length === 1) {
          return this.launch(searchResults[0]);
        }
      }
    } else if (e.key === 'Escape') {
      this.setState({ resultsOpened: false });
    }
  };

  hasResults() {
    return this.props.searchResults && this.props.searchResults.length > 0;
  }

  launchBook = element => {
    const url = `${ROUTES.CLASSROOM_BOOK.replace('_classId_', element.classroomId)}/${element.bookId}`;
    routerHistory.push(url);
  };

  launchUnit = element => {
    const url = `${ROUTES.CLASSROOM_BOOK.replace('_classId_', element.classroomId)}/${element.bookId}`;
    routerHistory.push(`${url}?selectedUnit=${element.unitId}`);
  };

  launch = element => {
    this.setState({ resultsOpened: false });
    return element.type === ACTIVITY_TYPE.BOOK ? this.launchBook(element) : this.launchUnit(element);
  };

  handleClose = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ resultsOpened: false });
    }
  };

  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  printResults = results => {
    return results.map(obj => {
      if (this.resultsPrinted === 5) {
        return;
      }

      this.resultsPrinted++;
      return (
        <div
          key={`${obj.lessonId}-${obj.bookName}-${obj.type}-${obj.classroomName}`}
          className="result"
          onClick={() => this.launch(obj)}
        >
          <img src={obj.imageUrl} alt={obj.name} />
          <div>
            <span className={'object-name'}>{obj.name}</span>
            <span className={'object-description'}>{obj.classroomName}</span>
          </div>
        </div>
      );
    });
  };

  render() {
    this.resultsPrinted = 0;

    return (
      <div className="navbar__searchbox" ref={this.setWrapperRef}>
        <div
          className={`searchbox ${this.searchMode() ? 'opened' : 'closed'}
        ${this.props.inputValue && this.state.resultsOpened ? 'results' : ''}`}
        >
          <div className="outer-wrapper">
            <i className="search custom-icons-magnifying-glass-browser" onClick={this.clickSearch} />
            <div className="inner-wrapper">
              <input
                className="search"
                type="text"
                placeholder=""
                ref={this.searchBoxInput}
                onClick={() => this.setState({ resultsOpened: true })}
                onChange={this.onInputChange}
                onKeyDown={this.onKeyDown}
                value={this.props.inputValue}
              />
              <i className="close custom-icons-close-button" onClick={this.clickClose} />
            </div>
          </div>
          {this.props.inputValue && this.searchMode() && this.state.resultsOpened && (
            <div className="searchbox__panel">
              <div className="header">
                <i className="search custom-icons-magnifying-glass-browser" />
                <span>{this.props.inputValue}</span>
              </div>
              <div className="results">
                {this.printResults(this.props.searchResults.filter(result => result.type === ACTIVITY_TYPE.LESSON))}
                {this.printResults(this.props.searchResults.filter(result => result.type === ACTIVITY_TYPE.UNIT))}
                {this.printResults(this.props.searchResults.filter(result => result.type === ACTIVITY_TYPE.BOOK))}
              </div>
              {!this.hasResults() && <p className="no-results">{I18n.t('search.noResults')}</p>}
            </div>
          )}
        </div>
      </div>
    );
  }
}
